import { useCrmLocale } from '../../ui/locale/crmLocale';
import { NavLink } from 'react-router-dom';
import CrmNavigationSidebar from './CrmNavigationSidebar';

export default function InstructorNavigation({ minimal = false }: { minimal?: boolean }) {
  const { t: crmText } = useCrmLocale();

  return <CrmNavigationSidebar label={crmText("Instructor navigation")}><nav>
    {!minimal && <NavLink to="/instructor" end aria-label={crmText("Dashboard")} title={crmText("Dashboard")}><i className="fas fa-chart-pie" /><span className="crm-nav-label">{crmText("Dashboard")}</span></NavLink>}
    <NavLink to="/instructor/profile" aria-label={crmText("Profile")} title={crmText("Profile")}><i className="fas fa-user" /><span className="crm-nav-label">{crmText("Profile")}</span></NavLink>
    <NavLink to="/instructor/payroll" aria-label={crmText("My Payroll")} title={crmText("My Payroll")}><i className="fas fa-wallet" /><span className="crm-nav-label">{crmText("My Payroll")}</span></NavLink>
  </nav></CrmNavigationSidebar>;
}
